import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import type { Contract } from '@coursera-web/enterprise-admin-types';

import _t from 'i18n!nls/enterprise-ui';

type Props = {
  contract: Contract;
};

export const RemainingUtilization = (props: Props): React.ReactElement => {
  const { contract } = props;
  const { remainingUserLicense, totalUserLicense, remainingEnrollment, totalEnrollment } = contract;
  const isFull = remainingEnrollment === 0 || remainingUserLicense === 0;

  if (contract?.limitType === 'USER_LICENSE_WITH_ENROLLMENT_CAP') {
    return (
      <React.Fragment>
        <FormattedMessage
          message={_t(`{remain} of {total} licenses;`)}
          remain={<strong>{remainingUserLicense}</strong>}
          total={totalUserLicense}
        />
        <br />
        <FormattedMessage
          message={_t(`{remain} of {total} enrollments`)}
          remain={<strong>{remainingEnrollment}</strong>}
          total={totalEnrollment}
        />
      </React.Fragment>
    );
  } else if (isFull) {
    return <strong>{_t('Full')}</strong>;
  } else if (contract?.limitType === 'NO_LIMIT') {
    return <strong>{_t('Unlimited')}</strong>;
  } else if (contract?.limitType === 'USER_LICENSE') {
    return (
      <FormattedMessage
        message={_t(`{remain} of {total}`)}
        remain={<strong>{remainingUserLicense}</strong>}
        total={totalUserLicense}
      />
    );
  } else if (contract?.limitType === 'ENROLLMENT_CAP') {
    return (
      <FormattedMessage
        message={_t(`{remain} of {total}`)}
        remain={<strong>{remainingEnrollment}</strong>}
        total={totalEnrollment}
      />
    );
  } else {
    return (
      <FormattedMessage
        message={_t(`{remain} of {total}`)}
        remain={<strong>{contract?.remainingUserLicense}</strong>}
        total={contract?.totalUserLicense}
      />
    );
  }
};

export default RemainingUtilization;
